<template>
  <div class="container" v-if="this.datosRegistro != null">

    <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
      <div
          class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
        <div class="mb-4 mb-xl-0">
          <div class="fs-3 fw-bold text-white">
            <span v-if="this.datosRegistro.id==null">Registrar Nueva Área de Sucursal</span>
            <span v-else>Editar Área de Sucursal</span>
          </div>
        </div>
      </div>
    </aside>

    <div class="row">
      <div class="col-4">
        <div class="btn-group" role="group"  style="width: 100%">
          <span class="text" style="margin: auto;">Cliente:</span>
          <v-select :options="optionsCliente" v-model="datosRegistro.id_cliente"
                  label="cliente"
                  :reduce="it => it.id"
                  class="m-4" placeholder="--Selecciona--"
                  style="width: 100%"
        />
        </div>
      </div>
      <div class="col-4">
        <div class="btn-group" role="group"  style="width: 100%">
          <span class="text" style="margin: auto;">Sucursal:</span>
          <v-select :options="optionsSucursal" v-model="datosRegistro.id_sucursal"
                    label="nombre_sucursal"
                    :reduce="it => it.id"
                    class="m-4" placeholder="--Selecciona--"
                    style="width: 100%"
          />
        </div>
      </div>
      <div class="col-4">
        <span class="text">Área:</span>
        <input v-model="datosRegistro.nombre_area_sucursal" class="m-4" type="text" placeholder="Área">
      </div>
    </div>
    <div class="row">
      <div class="col" align="center">
        <button class="btn btn-success " @click="registrar()">Guardar</button>
      </div>
      <div class="col" align="center">
        <button class="btn btn-danger " @click="cancelar()">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import {inject} from "vue";
import {AreaSucursalService} from "@/services/AreaSucursalService";
import {SucursalService} from "@/services/SucursalService";

export default {
  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_AreaSucursalService: new AreaSucursalService(inject('$axios')),
      srv_SucursalService: new SucursalService(inject('$axios')),
    }
  },
  props: {
    original: Object,
    optionsCliente: Array
  },
  data() {
    return {
      datosRegistro: {
        id: null,
        nombre_area_sucursal: null,
        id_cliente: null,
        id_sucursal: null
      },
      optionsSucursal: [],
      cargaTotal: false
    }
  },
  async mounted() {
    if (this.original != null && this.original.id != null) {
      await this.obtener();
      await this.obtenerSucursales();
      this.cargaTotal = true;
    }
  },
  watch: {
    async 'datosRegistro.id_cliente'() {
      if (this.cargaTotal) {
        await this.obtenerSucursales();
      }
    },
    optionsSucursal(){
      if (this.cargaTotal && (this.optionsSucursal == null
          || !this.optionsSucursal.some(it=>it.id === this.datosRegistro.id_sucursal)) ) {
        this.datosRegistro.id_sucursal = null;
      }
    }
  },
  methods: {
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_AreaSucursalService.obtener({
        nombre_area_sucursal: ""+this.original.id
      }).then((response) => {
        if (response != null && response.length > 0) {
          this.datosRegistro = response[0];
        }
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async registrar() {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_AreaSucursalService.cargar(this.datosRegistro).then((res) => {
        this.$swal(res.msj);
        this.cancelar();
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    cancelar() {
      this.$emit('_cancelarEditar');
    },

    async obtenerSucursales() {

      this.optionsSucursal = [];

      if (this.datosRegistro == null || this.datosRegistro.id_cliente == null) {
        return;
      }

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });


      await this.srv_SucursalService.obtener(
          {nombre_cliente:""+this.datosRegistro.id_cliente, registro_activo: true}
      ).then((response) => {
        this.optionsSucursal = response;
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    }
  }
}
</script>

<style scoped>

</style>